import React, { useState } from 'react';
import { Warehouse, Package, Box, Gift, Gem } from 'lucide-react';
import StockMatieres from '../Atelier/StockMatieres';
import StockComposants from './StockComposants';
import StockPackaging from './StockPackaging';

const TABS = [
  { key: 'composants',label: 'Stock Matières',         icon: Box,     gradient: 'from-blue-600 to-indigo-600' },
  { key: 'or',        label: 'Or & Métaux (achats)',    icon: Package, gradient: 'from-yellow-500 to-yellow-700' },
  { key: 'pierres',   label: 'Pierres & Diamants',     icon: Gem,     gradient: 'from-purple-500 to-purple-700' },
  { key: 'packaging', label: 'Packaging',               icon: Gift,    gradient: 'from-green-600 to-teal-600' },
];

function Stocks() {
  const [activeTab, setActiveTab] = useState('composants');

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center space-x-2">
          <Warehouse className="h-8 w-8" />
          <span>Gestion des stocks</span>
        </h2>
      </div>

      {/* Onglets */}
      <div className="bg-white rounded-lg shadow-md p-1 flex flex-wrap gap-1">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex-1 min-w-[130px] px-4 py-3 rounded-lg font-semibold transition-all flex items-center justify-center space-x-2 ${
                active
                  ? `bg-gradient-to-r ${tab.gradient} text-white shadow-md`
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Contenu */}
      {activeTab === 'or'         && <StockMatieres mode="or" />}
      {activeTab === 'pierres'    && <StockMatieres mode="pierres" />}
      {activeTab === 'composants' && <StockComposants />}
      {activeTab === 'packaging'  && <StockPackaging />}
    </div>
  );
}

export default Stocks;
